





import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class FadeTwin extends Vue {
  @Prop()
  public label: string;

  public onMouseEnter(label: string) {
    document.querySelectorAll('.dim-twin').forEach((i) => {
      const node: any = i.parentNode;
      return node.classList.add('dim-children');
    });
    document
      .querySelectorAll(`.dim-twin[data-label="${label}"]`)
      .forEach((i) => i.classList.add('undim-me'));
  }

  public onMouseLeave() {
    document
      .querySelectorAll('.dim-children')
      .forEach((i) => i.classList.remove('dim-children'));
    document
      .querySelectorAll('.undim-me')
      .forEach((i) => i.classList.remove('undim-me'));
  }
}
